import axios from "axios"

export default {
    TireSize:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehicledefinitions/tiresize/update' : '/api/vehicledefinitions/tiresize/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vehicledefinitions/tiresize/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/vehicledefinitions/tiresize/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/vehicledefinitions/tiresize/select/list')
            return response
        }
    },
    Brand:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehicledefinitions/vehiclebrand/update' : '/api/vehicledefinitions/vehiclebrand/create',data,{headers: { "Content-Type": "multipart/form-data" },})
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vehicledefinitions/vehiclebrand/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/vehicledefinitions/vehiclebrand/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/vehicledefinitions/vehiclebrand/select/list')
            return response
        }
    },
    BrandModel:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehicledefinitions/vehiclebrandmodel/updatec' : '/api/vehicledefinitions/vehiclebrandmodel/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vehicledefinitions/vehiclebrandmodel/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/vehicledefinitions/vehiclebrandmodel/table',data)
            return response
        },
        async ListByBrandId(data){
            const response = await axios.get(`/api/vehicledefinitions/vehiclebrandmodel/select/list/${data}`)
            return response
        }
    },
    BrandModelSerial:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehicledefinitions/vehiclebrandmodelserial/update' : '/api/vehicledefinitions/vehiclebrandmodelserial/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vehicledefinitions/vehiclebrandmodelserial/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/vehicledefinitions/vehiclebrandmodelserial/table',data)
            return response
        },
        async ListByBrandModelId(data){
            const response = await axios.get(`/api/vehicledefinitions/vehiclebrandmodelserial/select/list/${data}`)
            return response
        }
    },
    Type:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehicledefinitions/vehicletype/update' : '/api/vehicledefinitions/vehicletype/create',data,{headers: { "Content-Type": "multipart/form-data" },})
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vehicledefinitions/vehicletype/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/vehicledefinitions/vehicletype/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/vehicledefinitions/vehicletype/select/list')
            return response
        },
        async ListOnlyTwoStepByGroupNumber(groupNumber){
            const response = await axios.get(`/api/vehicledefinitions/vehicletype/select/list/onlytwostep/${groupNumber}`)
            return response
        },
        async ListByGroupNumber(groupNumber){
            const response = await axios.get(`/api/vehicledefinitions/vehicletype/select/list/${groupNumber}`)
            return response
        },
        async TreeList(){
            const response = await axios.get('/api/vehicledefinitions/vehicletypebasetype/select/treelist')
            return response
        },
        async Get(data){
            const response = await axios.post(`/api/vehicledefinitions/vehicletype/get/${data}`)
            return response
        }
    },
    Vehicle:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehicledefinitions/vehicle/update' : '/api/vehicledefinitions/vehicle/create',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/vehicledefinitions/vehicle/delete/${data}`)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/vehicledefinitions/vehicle/table',data)
            return response
        },
        async List(){
            const response = await axios.get('/api/vehicledefinitions/vehicle/select/list')
            return response
        }
    },
    BaseType:{
        async List(bool){
            const response = await axios.get(`/api/vehicledefinitions/vehicletypebasetype/select/list/${bool ? true : false}`)
            return response
        }
    }
}